import { Pipe, PipeTransform } from '@angular/core';
import { PersonName } from '../../../typings';

const DEFAULT_LOCALE = 'en-US';

@Pipe({
    name: 'nameFormat'
    // pure: false, FIXME use when subscribing to locale
    ,
    standalone: false
})
export class NameFormatPipe implements PipeTransform {
  private value: PersonName;
  private computed: string;

  transform(value: PersonName): string {
    if (value === this.value && this.computed) {
      return this.computed;
    }
    return (this.computed = NameFormatPipe.apply((this.value = value), value.locale || 'en-US'));
  }

  // FIXME remove locale parameter?
  static apply(value: PersonName, locale?: string): string {
    if (!value) return '';
    if (value.locale) locale = value.locale; // FIXME is this appropriate for display format?
    if ((locale || DEFAULT_LOCALE).startsWith('ja')) {
      return `${value.lastName} ${value.firstName}`;
    } else {
      return `${value.firstName} ${value.lastName}`;
    }
  }
}
